"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElementWidth = void 0;
const react_1 = __importDefault(require("react"));
function useElementWidth() {
    const [elementWidth, setElementWidth] = react_1.default.useState(0);
    const elementRef = react_1.default.useRef(null);
    const ref = react_1.default.useCallback((element) => {
        elementRef.current = element;
        if (element !== null) {
            setElementWidth(element.clientWidth);
        }
    }, []);
    react_1.default.useEffect(() => {
        if (elementRef.current) {
            setElementWidth(elementRef.current.clientWidth);
        }
    }, [elementRef.current]);
    react_1.default.useEffect(() => {
        let myVar;
        const handleResize = () => {
            if (elementRef.current && elementRef.current.clientWidth !== 0) {
                setElementWidth(elementRef.current.clientWidth);
                if (myVar) {
                    clearInterval(myVar);
                }
            }
        };
        if (!elementRef.current ||
            (elementRef.current && elementRef.current.clientWidth === 0)) {
            myVar = setInterval(handleResize, 1000);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            if (myVar) {
                clearInterval(myVar);
            }
        };
    }, []);
    react_1.default.useLayoutEffect(() => {
        if (elementRef.current) {
            const elementWidthAfterUpdate = elementRef.current.clientWidth;
            if (elementWidthAfterUpdate !== elementWidth) {
                setElementWidth(elementWidthAfterUpdate);
            }
        }
    }, [elementWidth]);
    return [elementWidth, ref];
}
exports.useElementWidth = useElementWidth;
